import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription, take } from 'rxjs';
import { Property } from '../../models/property';
import { Result } from '../../models/result';
import { BuyerRepresentationRequest } from '../../requests/buyerRepresentationRequest';
import { PropertyService } from '../../services/PropertyService';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { buyerRepresentationResultMessage } from '../buyer-representation-result-messages';

@Component({ standalone: false,
  selector: 'represent-buyer-dialog',
  templateUrl: 'represent-buyer-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class RepresentBuyerDialogComponent {
  title: string= "Represent Buyer";
  confirmButtonText = "Confirm";
  cancelButtonText = "Cancel";

  public representForm: FormGroup;

  property!: Property;

  busy:boolean=false;
  resultReceived:boolean=false;
  resultCode?:number;
  resultText:string='';

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<RepresentBuyerDialogComponent>, private propertyService:PropertyService) {
    this.representForm = new FormGroup({
      username: new FormControl<string | undefined>(undefined, Validators.compose([Validators.required, Validators.minLength(6)])),
    });
    if(data){
      this.property=data.property;
    }
  }

  get canSubmit(){
    return this.representForm.valid && !this.busy;
  }

  get canCancel(){
    return !this.busy;
  }

  onConfirmClick(): void {
    //show spinner
    this.busy=true;
    var brr = new BuyerRepresentationRequest();
    brr.propertyId=this.property.id;
    brr.buyerUserName=this.representForm.value.username;
    this.propertyService.representBuyer(brr).pipe(take(1)).subscribe(r=>this.processBuyerRepresentationRequestResult(r));
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  private processBuyerRepresentationRequestResult(result:Result){
    this.cancelButtonText="OK";
    this.resultReceived=true;
    this.busy=false;
    const message = buyerRepresentationResultMessage(result);
    this.title = message.title;
    this.resultText = message.text;
  }

}